import { render, staticRenderFns } from "./TenderGeneralInformation.vue?vue&type=template&id=fda45fbe"
import script from "./TenderGeneralInformation.vue?vue&type=script&lang=js"
export * from "./TenderGeneralInformation.vue?vue&type=script&lang=js"
import style0 from "./TenderGeneralInformation.vue?vue&type=style&index=0&id=fda45fbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports